import React, { useEffect } from 'react';
import { Button, Col, Form, FormGroup, Label, UncontrolledTooltip } from 'reactstrap';
import { Field, reduxForm, change } from 'redux-form';
import ValidatedInput from "../../../components/ValidatedInput";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faQuestionCircle, faSpinner } from "@fortawesome/free-solid-svg-icons";
import { formatSSN } from "../../../utils/helper";

const AccountOwnerSocialSecurityNumber = ({ nextStep, prevStep, handleSubmit, active, processing, secondary, dispatch, investAccount }) => {

    useEffect(() => {
        if (active && investAccount && investAccount.id) {
            if (secondary) {
                dispatch(change('AccountOwnerSocialSecurityNumberForm', 'ssn', investAccount.secondary_account_owner_ssn || null));
            } else {
                dispatch(change('AccountOwnerSocialSecurityNumberForm', 'ssn', investAccount.primary_account_owner_ssn || null));
            }
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [active, investAccount]);

    const handleNext = (formData) => {
        let payload = {};
        if (secondary) {
            payload.secondary_account_owner_ssn = formData.ssn;
        } else {
            payload.primary_account_owner_ssn = formData.ssn;
        }
        nextStep(payload);
    };

    const handleBack = () => {
        prevStep();
    };

    return (
        <div className={`account-setup-wrapper ${!active ? 'd-none' : ''}`}>
            <Form className="form-container" onSubmit={handleSubmit(handleNext)}>
                <div className="back-btn">
                    <Button color="link" onClick={handleBack}>back</Button>
                </div>
                <div className="form-header mt-md-3 mt-0">
                    <h2>{secondary ? 'SECONDARY' : 'PRIMARY'} ACCOUNT OWNER</h2>
                    <span>To confirm identity, provide your social security number</span>
                </div>
                <div className="account-info-container">
                    <FormGroup row>
                        <Label sm={5}>Social Security Number</Label>
                        <Col sm={6}>
                            <Field
                                component={ValidatedInput}
                                type="text"
                                format={formatSSN}
                                name="ssn"
                                placeholder="xxx-xx-xxxx" />
                        </Col>
                        <div sm={1} xs={2}>
                            <span id="sec-number-tooltip">
                                <FontAwesomeIcon icon={faQuestionCircle} />
                            </span>
                            <UncontrolledTooltip innerClassName="text-left fs12" placement="right" target="sec-number-tooltip">
                                All your data is protected by bank-level security and 256-bit encryption.
                            </UncontrolledTooltip>
                        </div>
                    </FormGroup>
                </div>
                <div className="button_wrapper">
                    <button className="custom-btn-primary" type="submit" disabled={processing}>
                        NEXT STEP {processing && <FontAwesomeIcon icon={faSpinner} spin />}
                    </button>
                </div>
            </Form>
        </div>
    )
};

const validate = (values) => {
    const errors = {};
    if (!values.ssn) {
        errors.ssn = 'Field is required';
    }
    if (values.ssn && !/\d{3}[-]\d{2}[-]\d{4}/.test(values.ssn)) {
        errors.ssn = 'Invalid value';
    }
    return errors;
};

export default reduxForm({
    form: 'AccountOwnerSocialSecurityNumberForm',
    validate,
})(AccountOwnerSocialSecurityNumber);
